import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./CookieNotice.scss";
import { LIGHT_ONLY as NO_NOTICE_ROUTES } from "../../theme/lightOnlyRoutes";

/*
  Уведомление о cookie. Именно уведомление, а не согласие: аналитика не
  ждёт нажатия и не блокируется — плашка только сообщает.

  Появляется через 2 с после первой отрисовки, position: fixed — в поток не
  входит, в CLS не попадает. Ссылки «Подробнее» пока нет: её добавим вместе
  с текстом политики, когда он придёт от юриста.
*/
const STORAGE_KEY = "nets_cookie_notice";
const SHOW_DELAY_MS = 2000;

/* В приватном режиме localStorage бросает — тогда просто показываем снова. */
const alreadySeen = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch (e) {
    return false;
  }
};

const remember = () => {
  try {
    localStorage.setItem(STORAGE_KEY, "1");
  } catch (e) {
    /* живём без запоминания */
  }
};

const CookieNotice = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  const excluded = NO_NOTICE_ROUTES.some((re) => re.test(pathname));

  useEffect(() => {
    if (excluded || alreadySeen()) return undefined;
    const t = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    return () => clearTimeout(t);
  }, [excluded]);

  if (!visible || excluded) return null;

  const accept = () => {
    remember();
    setVisible(false);
  };

  return (
    <div className="cookieNotice" role="status">
      <p className="cookieNotice_text">
        Сайт использует cookie и аналитику, чтобы работать стабильно и
        становиться лучше.
      </p>
      <button type="button" className="cookieNotice_btn" onClick={accept}>
        Понятно
      </button>
    </div>
  );
};

export default CookieNotice;
